import client from "client/client";
import {FileResource} from "~/client/resources/fileResource";

export default class FilesRepository {
    private rootUri = "/api/cloud-portal-files";

    /**
     * 
     * @param cloudPortalFiles The relative path of cloud portal files.
     */
    getCloudPortalFiles(cloudPortalFiles? : string[]) : Promise<FileResource[]> {
        return client.get(`${this.rootUri}{?cloudPortalFiles*}`, {cloudPortalFiles});
    }

    getUrlToCloudPortalFileContent(file: FileResource, justification: string) {
        return client.resolve(`${this.rootUri}/content{?relativePath,justification}`, {relativePath: file.RelativePath, justification});
    }

    deleteCloudPortalFile(file: FileResource) {
        return client.del(`${this.rootUri}{?relativePath}`, {
            args: {relativePath: file.RelativePath}
        });
    }
    
    
}